import { useRef, useCallback } from 'react';
/**
 * Хук для вызова функции по истечению таймера.
 */
export function useTimeoutCallback(handler, timeout) {
    const timeoutIdRef = useRef();
    const cancel = useCallback(() => {
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = undefined;
    }, []);
    const run = useCallback(() => {
        const id = setTimeout(handler, timeout);
        timeoutIdRef.current = id;
    }, [handler, timeout]);
    return [run, cancel];
}
